"use client";
import React, { useState, useRef, useEffect, useContext } from "react";
import { Search, Bell, Settings, User, Menu } from "lucide-react";
import { Link,useNavigate } from "react-router-dom";
import LogoutModal from "./LogoutModal";
import { useAppContext } from "../App";
import ReactDOM from "react-dom";
import { NotificationContext } from "./context/NotificationContext";
import { useSettings } from "./context/SettingsContext";
import { CDN_URL, IMAGE_BASE_URL } from "./config/apiconfig";
const DashboardHeader = () => {
  const navigate = useNavigate();
  const context = useAppContext();
const { getProfile } = useSettings();
const [profile, setProfile] = useState(null);
useEffect(() => {
  const fetchProfile = async () => {
    const adminId = localStorage.getItem("admin_id");
    if (!adminId) return;

    const response = await getProfile(adminId);

    if (response?.status === 200) {
      setProfile(response.data);
    }
  };

  fetchProfile();
}, [getProfile]);   // ✅ add this
  const { isCollapsed, isMobileMenuOpen, setIsMobileMenuOpen } = context || {};
const userRef = useRef(null);
const [userDropdownPos, setUserDropdownPos] = useState({ top: 0, right: 0 });
  const { notifications, loading, deleteNotification } =
    useContext(NotificationContext);

  // Single ref that wraps the interactive area (header)
  const containerRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  
const unreadCount = notifications.filter((n) => n.unread).length;

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching for:", searchQuery);
  };

  const handleSignOut = () => {
    setShowUserMenu(false);
    setShowLogoutModal(true);
  };

  const handleMobileMenuToggle = () => {
    if (setIsMobileMenuOpen) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    }
  };
/* inside DashboardHeader component */
const bellRef = useRef(null);
const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });

/* helper to compute and set position */
const updateDropdownPosition = () => {
  if (!bellRef.current) return;
  const rect = bellRef.current.getBoundingClientRect();
  // place the dropdown aligned to the right edge of the bell button
  // adjust offsets as needed (vertical offset: 10px; horizontal use rect.right)
  const top = rect.bottom + 10 + window.scrollY;
  const right = window.innerWidth - rect.right + 8; // keep small right offset
  setDropdownPos({ top, right, width: 320 }); // width used in style, adjust if needed
};

const updateUserDropdownPosition = () => {
  if (!userRef.current) return;

  const rect = userRef.current.getBoundingClientRect();

  const top = rect.bottom + 10 + window.scrollY;
  const right = window.innerWidth - rect.right;

  setUserDropdownPos({ top, right });
};
useEffect(() => {
  if (showUserMenu) {
    updateUserDropdownPosition();
    window.addEventListener("resize", updateUserDropdownPosition);
    window.addEventListener("scroll", updateUserDropdownPosition, true);
  }

  return () => {
    window.removeEventListener("resize", updateUserDropdownPosition);
    window.removeEventListener("scroll", updateUserDropdownPosition, true);
  };
}, [showUserMenu]);
/* when opening, compute position and add listeners */
useEffect(() => {
  if (showNotifications) {
    updateDropdownPosition();
    window.addEventListener("resize", updateDropdownPosition);
    window.addEventListener("scroll", updateDropdownPosition, true);
  }
  return () => {
    window.removeEventListener("resize", updateDropdownPosition);
    window.removeEventListener("scroll", updateDropdownPosition, true);
  };
}, [showNotifications]);
  // Unified outside-click handler for both notifications and user menu
  useEffect(() => {
    function handleClickOutside(event) {
      // If ref exists and click target is outside it => close menus
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowNotifications(false);
        setShowUserMenu(false);
      }
    }

    // Only attach the listener when at least one menu is open
    if (showNotifications || showUserMenu) {
    document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showNotifications, showUserMenu]);

  return (
    <>
      <header className="bg-white bg-opacity-80 backdrop-blur-lg border-b border-orange-200 ">
        {/* attach the ref to the immediate container that wraps buttons/dropdowns */}
        <div className="flex items-center justify-between" ref={containerRef}>
          {/* Left Section - Mobile menu button and Search */}
          <div className="flex items-center gap-2 sm:gap-4 flex-1 max-w-2xl">
            <button
              onClick={handleMobileMenuToggle}
              className="p-2 hover:bg-orange-100 rounded-lg transition-colors lg:hidden"
              aria-label="Toggle mobile menu"
            >
              <Menu className="w-8 h-8 text-gray-600" />
            </button>

            {/* <form onSubmit={handleSearch} className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 sm:w-5 sm:h-5" />
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-8 sm:pl-10 pr-4 py-2 sm:py-2.5 bg-white bg-opacity-70 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-teal-400 transition-all duration-300 text-sm sm:text-base"
              />
            </form> */}
          </div>

          {/* Right Section - Actions */}
          <div className="flex items-center gap-2 sm:gap-3">
            {/* Notifications */}
          <div className="relative">
  <button
    ref={bellRef}
    onClick={() => {
      setShowNotifications((s) => !s);
      setShowUserMenu(false); 
    }}
    className="relative p-2 hover:bg-orange-100 rounded-lg transition-colors"
    aria-label="View notifications"
  >
    <Bell className="w-5 h-5 text-gray-600" />
    {unreadCount > 0 && (
      <span className="absolute -top-1 -right-1 w-4 h-4 sm:w-5 sm:h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium">
        {unreadCount}
      </span>
    )}
  </button>

  {showNotifications &&
    ReactDOM.createPortal(
      <div
        style={{
          position: "absolute",
          top: dropdownPos.top + "px",
          right: dropdownPos.right + "px",
          width: dropdownPos.width + "px",
          zIndex: 2147483647 
        }}
      >
        <div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
          <div className="p-4 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-800">Notifications</h3>
              {unreadCount > 0 && <span className="text-sm text-teal-600 font-medium">{unreadCount} new</span>}
            </div>
          </div>

          <div className="max-h-80 overflow-y-auto">
            {notifications.map((notification) => (
              <div key={notification.id} className={`p-4 border-b border-gray-50 hover:bg-gray-50 transition-colors ${notification.unread ? "bg-teal-50" : ""}`}>
                <div className="flex items-start gap-3">
                  <div className={`w-2 h-2 rounded-full mt-2 flex-shrink-0 ${notification.unread ? "bg-teal-500" : "bg-gray-300"}`}></div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-gray-800 mb-1 truncate">{notification.title}</h4>
                    <p className="text-sm text-gray-600 mb-2 line-clamp-2">{notification.message}</p>
                    <span className="text-xs text-gray-500">{notification.time}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="p-4 border-t border-gray-100">
            <button
              onClick={(e) => {
                 e.stopPropagation(); 
                setShowNotifications(false);
                navigate("/notification");
              }}
              className="w-full text-center text-sm text-teal-600 hover:text-teal-800 font-medium"
            >
              View All Notifications
            </button>
          </div>
        </div>
      </div>,
      document.body
    )}
</div>

            {/* Settings */}
            <Link to="/settings" className="p-2 hover:bg-orange-100 rounded-lg transition-colors hidden sm:block" aria-label="Settings">
              <Settings className="w-5 h-5 text-gray-600" />
            </Link>

            {/* User Menu */}
           <div className="relative z-[9999]">

           {/* <button
  ref={userRef}
  onClick={() => {
    setShowUserMenu(s => !s);
    setShowNotifications(false);
  }}

                className="flex items-center gap-2 sm:gap-3 p-1 sm:p-2 hover:bg-orange-100 rounded-lg transition-colors"
                aria-label="User menu"
              >
            <div className="w-8 h-8 rounded-full overflow-hidden bg-teal-600 flex items-center justify-center">
  {profile?.image ? (
   <img
  src={`${CDN_URL}/${encodeURIComponent(profile.image)}?t=${Date.now()}`}
  alt="Profile"
  className="w-full h-full object-cover"
/>
  ) : (
    <span className="text-white text-sm font-bold">
      {profile?.first_name?.charAt(0) || "A"}
    </span>
  )}
</div>

                <div className="hidden md:block text-left">
                 <p className="text-sm font-medium text-gray-800 truncate">
  {profile?.first_name} {profile?.last_name}
</p>
<p className="text-xs text-gray-600 truncate">
  {profile?.email}
</p> </div>

              </button> */}
<div className="border-t border-gray-100 py-3">
  <button
    onClick={handleSignOut}
    className="w-full px-4 py-3 text-left text-xl font-medium text-red-600 hover:bg-red-50 flex items-center  rounded-md"
  >
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      />
    </svg>

    
  </button>
</div>
              {/* {showUserMenu &&
  ReactDOM.createPortal(
    <div
      style={{
        position: "absolute",
        top: userDropdownPos.top + "px",
        right: userDropdownPos.right + "px",
        width: "260px",
        zIndex: 2147483647,
        background:" #ffff"
      }}
    >
                 <div className="p-4 border-b border-gray-100">
                    <div className="flex items-center gap-3">
                   <div className="w-8 h-8 rounded-full overflow-hidden bg-teal-600 flex items-center justify-center">
  {profile?.image ? (
   <img
  src={`${CDN_URL}/${encodeURIComponent(profile.image)}?t=${Date.now()}`}
  alt="Profile"
  className="w-full h-full object-cover"
/>
  ) : (
    <span className="text-white text-sm font-bold">
      {profile?.first_name?.charAt(0) || "A"}
    </span>
  )}
</div>
                      <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-800">
  {profile?.first_name} {profile?.last_name}
</p>
<p className="text-xs text-gray-600">
  {profile?.email}
</p>  </div>
                    </div>
                  </div>
                  <div className="py-2">
                    <Link to="/settings" className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3" onClick={() => setShowUserMenu(false)}>
                      <User className="w-4 h-4" />
                      Profile Settings
                    </Link>
                    <Link to="/settings" className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3 sm:hidden" onClick={() => setShowUserMenu(false)}>
                      <Settings className="w-4 h-4" />
                      Settings
                    </Link>
                  <Link
  to="/settings#password"
  className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3"
  onClick={() => setShowUserMenu(false)}
>
  <Settings className="w-4 h-4" />
  Account Settings
</Link>
                  </div>
                  <div className="border-t border-gray-100 py-2">
                    <button onClick={handleSignOut} className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-3">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Sign Out
                    </button>
                  </div>
                </div>,
                document.body
              )} */}
            </div>
          </div>
          
        </div>
      </header>

      {/* Logout Modal */}
      {showLogoutModal && <LogoutModal isOpen={showLogoutModal} onClose={() => setShowLogoutModal(false)} />}
    </>
  );
};

export default DashboardHeader;
